var us = {
  title: 'MEPP',
  header:{
    home: 'Home',
    login: 'Log In',
    logout: 'Log out',
    registration: 'Sign up',
    add: 'Add',
    forum: 'Forum',
    pets: 'pets',
    welcome: 'Welcome, ',
    notifications: 'Notifications ',
    contacts: 'Contacts',
    menu: 'Navigation',
    services: 'Services',
    logoText: 'The best care for pets and their people!',
    cookies: 'This site uses cookies to work optimally for you.',
    cookiesButton: 'Read more',
    cookiesClose: 'Understood'
  },
  seo:{
    title: "Your Pet's Electronic Passport",
    description: 'A platform for organizing all the necessary veterinary examinations for your pet.'
  },
  statistic:{
    title: 'Statistics for monthly registrations and payments',
    users: 'Users',
    pets: 'Pets',
    pay: 'Annual fees paid',
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    yearStatistic: 'Annual statistics'
  },
  homePage:{
    servicesTitle: 'Welcome to MEPP - the electronic passport of your pet!',
    vets: 'How to choose the best veterinarian?',
    vetsMessage: "The question of choosing a personal physician is as complex as in humans as it is in animals. That is why we offer you a long list of registered veterinarians, from which you can choose the most suitable for the care of your dear creature. You could add more than one, each with access to your pet's health record so that treatment is always adequate and professional.",
    firstParagraf: "With just a few clicks, you have complete information, so caring for your pet has never been easier. You will have access to your best friend's health card quickly and from anywhere in the world. MEPP ​​is here to be helpful for you as a owner, to your hairy friend and especially to its vet. If your pet gets lost or disappears, MEPP will take it home. It is enough for him to have a chip and to appear in the database of the network of veterinarians who have trusted the platform. Its intuitive design and multifunctionality make it one of the most coveted pet software!",
    reviewTitle: 'Medical examinations',
    reviewMessage: "We all know, that vaccination and preventive examinations are especially important for the health and the long live of our beloved creature. It's imperative to be aware of all the interventions they go through. MEPP gives the opportunity not only to you, but also to your veterinarian to have access to a complete health card, to update it and thus provide the most sought after care for your best friend.",
    autoCreateTiile: 'Notifications',
    autoCreateMessage: 'In our hectic daily lives, we often miss important details. One of them is the time to visit our veterinarian. To make sure that this does not happen, MEPP sends direct notifications according to the following set schedule: a week in advance, one day in advance and on the day itself. MEPP thinks for you, works for the health of the pet by direct synchronization of information between the owner and the veterinarian. Each notification is associated with a specific procedure, which you can set from the extremely convenient calendar and list of services.',
    lostPetTtile: 'Lost pet?',
    lostPetMessage: "The biggest fear of every owner is that his pet is missing. MEPP has an answer to this problem as well. When registering in the system, you receive an individual identification code, which is also associated with your animal's chip. Thus, if it is taken to any clinic that has an account in the platform, the veterinarian on duty will be able to find you through it and inform you where it is located.",
    lostPetMessage2: 'Live without fear and worries!',
    featureServicesTitle: 'Coming soon!',
    featureServicesitle1: 'Appearance',
    featureServicesBooking1: 'Many breeds of dogs and cats need professional care for their flawless appearance. Sometimes it is not just a matter of whim and vanity, but of health. Therefore, through MEPP you will receive information where you could find the most suitable for the breed services of this type.',
    featureServicesitle2: 'Healthy eating',
    featureServicesBooking2: 'MEPP will not only help you to be always on the line for the health needs of your pet, but also how to avoid unwanted visits to the vet. This is sometimes achieved through some basic techniques. However, it all starts with proper nutrition. From us you will learn about which foods are most suitable for each animal according to its specifics for age, weight, breed, etc.',
    priceTitle: 'Price?',
    boricaSrc: '/img/logo-en.svg',
    boricaUrl: 'https://www.borica.bg/en',
    priceMessage: 'You can use all the services offered by MEPP for 1,04 USD per month. Payment is made on an annual basis upon registration of the pet, you pay 12,50 USD for the entire calendar year! Payment is made through a virtual POS terminal provided by',
    freePriceMessage: 'The platform is completely free to use, both for veterinarians and pet owners...',
    services: 'What services we offer?',
    firstSlide: 'Make a registration',
    secondSlide: 'Add your pet',
    thirdSlide: 'Start adding medical examinations',
    fourSlide: 'Find and give access to your vet'
  },
  contact:{
    firm:'Company name: K&D Synergy LTD',
    phone: 'Phone Number: 0886 54 21 29',
    email: 'Email: myepet.passport@gmail.com',
    address: 'Bulgaria, Sofia 1000, Mladost 1 neighborhood, bl.40, fl.6, ap.21',
    form: 'Or you can contact with us with our form for contacts',
    title: 'Contacts',
    theme: 'Topic',
    sendEmail: 'Your message was send succesfuly!'
  },
  button:{
    submit: 'Send',
    update: 'Update',
    addImage: 'Add photo',
    removeImage: 'Remove photo',
    delete: 'Yes',
    noDelete: 'Cancel',
    add: 'Add',
    remove: 'Close',
    uploadVideo: 'Upload video',
    petLose: 'Lost',
    search: ' Search',
    clear: 'Clear',
    addFavoriteDoctor: 'Add to favorite',
    removeFavoriteDoctor: 'Remove',
    ok: 'Ok',
    yes: 'Yes',
    create: 'Create',
    terms: 'terms to use',
    gdprTitle: 'Private policy',
    gdpr: 'private policy',
    and: ' and ',
    agreeTerms: 'I agree with the terms and conditions ',
    resetPass: 'Forgot your password?',
    approvе: 'Approve',
    favorite: 'Favorite',
    termsHeader: 'Terms & Conditions',
    patientAgree: 'The pet owner is familiar with ',
    patientAgreeWith: ' of the system and agrees to be registered.'
  },
  userNotification:{
    notificationTitle: 'Notifications',
    noNotification: "You haven't new notifications!",
    tommorow: 'Tommorow',
    afterWeek: ' should be done ',
    of: ' of ',
    ofWeek: 'On ',
    createReview: 'Do you want to create a veterinary examination?',
    notificationDescription: 'From here, you can view messages related to your pet',
    disableInfo: 'Your pet passport can be approved by your veterinarian and the "Identification" section will not be editable.'
  },
  registration:{
    email: 'Email',
    firstName:'Name',
    lastName:'Last Name',
    doctorFirstName: 'Name',
    doctorLastName: 'Last Name',
    phoneNumber: 'Phone number',
    password: 'Password',
    passwordLenth: ' (should contain at least 6 characters!)',
    passwordLenthError: 'your password should contain at least 6 characters!',
    field: 'Field',
    validEmail: 'Please enter a valid email address',
    error: "it's wrong!",
    required: "it's required!",
    correct: 'Моля попълнете полетата коректно',
    updateCorrect: 'Yor profile is updated!',
    requiredField: 'All the fields indicated with ',
    areRequired: ' are mandatory!',
    titleRegistration: 'Sign up as: ',
    titleLogin: 'Log in as: ',
    user : 'User',
    doctor: 'Veterinarian',
    imageUpload: 'Photo successfully uploaded!',
    removeUpload: 'Photo successfully removed!',
    videoUpload: 'Video successfully uploaded!',
    clinic: 'Clinic',
    website: 'Website',
    requiredSymbol: '*',
    newPass: 'Your new password (over 6 characters)!',
    language: 'Language',
    regNumber: 'Registration №',
    haveRegistartion: 'You are already registered?',
    noRegistration: 'You have no registration?',
    createPatientSuccess: 'You added successfully ',
    createPatientSendEmail: 'An email has been sent to the pet owner!'
  },
  updateProfile: {
    oldPassword: 'Please enter your old password',
    newPaswword: 'Please enter your new password',
    country: 'Country',
    city: 'City',
    neighborhood: 'Area',
    validPhoneNumber: 'Please enter a valid phone number',
    sendEmail: 'You have successfully updated your password. Please check your email!',
    passwordChange: 'Change password'
  },
  modalText:{
    modalHeader: 'Attention!',
    userWarning: 'You have changed information that is not saved.',
    modalQuestion: 'Do you want to save it?',
    modalSaveButton: 'Save',
    deletePetReview: 'Are you sure you want to delete the veterinary exam for ',
    deleteProfile: 'Are you sure you want to delete your account?',
    yes: 'Yes',
    no: 'No'

  },
  users: {
    profile: 'My Profile '
  },
  profile: {
    previewProfile: 'Personal information',
    altImage: 'Profile_picture_',
    address: 'Address',
    edit: 'Edit',
    owner: 'Owner ',
    space: ' ',
    userProfile: 'Pet owner',
    deleteProfile: 'Delete profile',
    ifDelete: 'If you delete your account you will lose all information related to your pet that is stored in the system!'
  },
  notifications:{
    notifHeader: 'Receive notifications',
    byEmail: 'by email',
    byMApp: 'by app: ',
    on: 'On',
    off: 'Off'

  },
  pets: {
    pets: 'Pets',
    pet: 'Pet: ',
    addPet: 'add a pet',
    description: 'Description',
    identification: 'Identification',
    pedigree: 'Genealogy',
    name: "Pet's name",
    species: 'Species',
    breed: 'Breed',
    sex: 'Gender',
    birthDate: 'Date of birth',
    coat: 'Coat',
    microchip: 'Microchip number',
    microchipping: 'Microchipping',
    dateMicrochipping: 'Date Microchipping',
    tattooNumber: 'Tattoo Number',
    tattooDate: 'Date of tattoo',
    kennel: 'Kannel',
    mother: 'Mother',
    createPet: 'You have successfully registered your pet',
    updateInfo: 'You have successfully updated your pet information',
    father: 'Father',
    doctorApprove: 'Please consult your veterinarian to approve the information for this passport!',
    appRovedPassport: 'Approved by:',
    disabledInformation: 'Attention after approval of the passport, the "Identification" section will not be available for editing!',
    noPets: 'You have no pets added yet!',
    profile: 'Profile',
    yourPets: 'From here you can see your pets',
    successPayment: 'Your one year payment for ',
    successPayment2:' is successful! Next payment after: 365 days.'

  },
  presentation: {
    title: 'How does MEPP work?',
    owners: 'For pet owners',
    vets: 'For veterinarians',
    ownersLink: 'https://www.youtube.com/embed/kKcw9_xgFLg',
    vetsLink: 'https://www.youtube.com/embed/9u2z4OEU-4o'
  },
  petProfile: {
    previewPetProfile: 'Viewing the profile of ',
    identNumber: 'Identification number',
    hide: 'Hide profile',
    show: 'Show profile',
    delete: 'Delete',
    addReview: 'Add veterinary examination',
    pacients: 'Patients'
  },
  modals:{
    petReview: 'Add examination to ',
    modalPetBody: 'Are you sure you want to delete the profile of ',
    modalPetReview: 'Are you sure you want to delete this examination?'
  },
  petReview: {
    options: [
      {
        text: 'Rabies vaccination',
        value: 'VAR',
        iconSrc: '/img/1-bqs.svg',
        iconSrcW: '/img/1-bqs-white.svg'
      },
      {
        text: 'Other vaccination',
        value: 'OV',
        iconSrc: '/img/2-vaksina.svg',
        iconSrcW: '/img/2-vaksina-white.svg'
      },
      {
        text: 'Treatment against ectoparasites (fleas, ticks)',
        value: 'TT',
        iconSrc: '/img/3-ekto.svg',
        iconSrcW: '/img/3-ekto-white.svg'
      },
      {
        text: 'Echinococcosis treatment',
        value: 'ET',
        iconSrc: '/img/4-ehino.svg',
        iconSrcW: '/img/4-ehino-white.svg'
      },
      {
        text: 'Latest heat',
        value: 'PR',
        iconSrc: '/img/5-pr.svg',
        iconSrcW: '/img/5-pr-white.svg'
      },
      {
        text: 'Мedical tests',
        value: 'IZ',
        iconSrc: '/img/6-izsledwane.svg',
        iconSrcW: '/img/6-izsledwane-white.svg'
      },
      {
        text: 'Seizures/Fits',
        value: 'anAttack',
        iconSrc: '/img/7-pristap.svg',
        iconSrcW: '/img/7-pristap-white.svg'
      },
      {
        text: 'Surgery',
        value: 'operation',
        iconSrc: '/img/8-operaciq.svg',
        iconSrcW: '/img/8-operaciq-white.svg'
      },
      {
        text: 'Legalization',
        value: 'legalisation',
        iconSrc: '/img/9-legalizaciq.svg',
        iconSrcW: '/img/9-legalizaciq-white.svg'
      },
      {
        text: 'Others',
        value: 'Others',
        iconSrc: '/img/10-drugi.svg',
        iconSrcW: '/img/10-drugi-white.svg'
      }
    ],
    filters: [
      {
        text: 'Rabies vaccination',
        value: 'VAR'
      },
      {
        text: 'Other vaccination',
        value: 'OV'
      },
      {
        text: 'Treatment against ectoparasites (fleas, ticks)',
        value: 'TT'
      },
      {
        text: 'Echinococcosis treatment',
        value: 'ET'
      },
      {
        text: 'Latest heat',
        value: 'PR'
      },
      {
        text: 'Medical tests',
        value: 'IZ'
      },
      {
        text: 'Seizures/Fits',
        value: 'anAttack'
      },
      {
        text: 'Surgery',
        value: 'operation'
      },
      {
        text: 'Legalization',
        value: 'legalisation'
      },
      {
        text: 'Others',
        value: 'Others'
      },
      {
        text: 'All',
        value: null
      }
    ],
    days: [
      {
        text: 'without reminder',
        value: '0'
      },
      {
        text: '15 days',
        value: '15'
      },
      {
        text: '1 month',
        value: '30'
      },
      {
        text: '3 month',
        value: '90'
      },
      {
        text: '6 month',
        value: '182'
      },
      {
        text: '1 year',
        value: '365'
      }
    ],
    prText: 'Latest heat',
    izText: 'Medical tests',
    imageFromIz: 'Photo from the medical examination',
    uploadImageSuccess: 'Photo successfully attached!',
    uploadImageError: 'Photo not attached!',
    userAddReview: 'to add a examination, please use the button ',
    manufacturer: 'Manufacturer',
    nameOfVaccine: 'Vaccine name',
    nameOfProduct: 'The name of the medicine',
    batchNumber: 'Batch number',
    vaccinationDate: 'Date of vaccination:',
    date: 'Date',
    validUntil: 'A reminder of',
    remaindingOn: 'Notice of',
    comment: 'Comment',
    legalisationBody: 'Subject to legalization',
    filterBy: 'Show: ',
    uploaded: 'Video successfully uploaded!',
    owner: 'Owner ',
    addByDoctor: 'Dr. ',
    titleReview: 'Examination',
    titleAddDate: 'Date:',
    tiitleNotificationDate: 'Date notification',
    tiitleNotificationDateMobile: 'Notification ',
    adddByTitle: 'Added the examination',
    adddByTitleMobile: 'Added',
    reviews: 'Examinations',
    noReviews: 'There are no Examinations for '

  },
  doctor:{
    doctors: 'My veterinarians',
    regVtes: 'Search for registered veterinarians',
    filter: 'Filter',
    or: 'or',
    searchPetHeader: 'Search for a pet by: ',
    noResult: 'No vets found!',
    noFindResult: 'No results found!',
    ownerSearching: 'To find the pet owner, please enter the microchip number!',
    addPetReview: 'To add a examination, find pet by ID or microchip number',
    noVet: "You don't have any favorite vets yet. In order for the vet to view, rub, and add examinations, you must have added him to your 'Favorite Vets'!",
    searchDoctorHeader: 'Find a vet',
    favoriteDoctors: 'Favorite vets: ',
    favoriteDoctorsHeader: 'Favorite vets',
    noFavoriteDoctors: 'No favorite vets added!',
    searchDoctorHeaderCriteria: 'Find veterinarian:',
    successAdd: 'You have successfully added ',
    inFav: ' at your favorite vets!',
    addedVet: ' has already been added to your list of favorite vets!',
    deleteVet: 'Are you sure you want to remove dr. ',
    fromFav: ' from your list of favorite vets?',
    searchVet: 'From here you can search for vets',
    addPatient: 'Add patient',
    paymentDoctor: 'For each annual fee paid by each of your patients, you receive 30% for the first fee and 10% for each subsequent one!'
  },
  errors: {
    imageError: 'Invalid image format!',
    videoError: 'Invalid video format!',
    doctorSearchError: 'Please enter search criteria!'
  },
  serverError: {
    serverError: 'An error occurred',
    invalidEmail: 'Invalid email address!',
    busyEmail: 'The email you entered is already registered!',
    emptyEmail: 'Please enter your email!',
    validEmail: 'Please enter a valid email address!',
    wrongEmail: 'The email address you entered is incorrect!',
    invalidFirstName: 'Invalid format for your name, please enter your name!',
    firstNameLengt: 'Your name must be a minimum of 3 letters!',
    firstNameSymbol: 'Your name may contain letters and blank spaces!',
    invalidLastName: 'Invalid format for your last name, please enter your last name!',
    LastNameLengt: 'Your family name must be at least 3 letters long!',
    LastNameSymbol: 'Your family may contain letters and blank distances!',
    emptyPassword: 'Please enter your password!',
    passwordLengt: 'Your password must be at least 6 characters long!',
    wrongPassword: 'The password you entered is incorrect!',
    oldPassword: 'Your old password must be at least 6 characters long!',
    newPassword: 'Your new password must be at least 6 characters long!',
    petName: 'Please enter the name of your pet!',
    petNameLengt: 'Your pet name must be at least 3 letters long!',
    petNameSymbol: "Your pet's name may contain letters and blank spaces!",
    emptyPetSpecies: 'Enter the type of your pet!',
    petSpeciesSymbol: 'Your pet type may contain letters and blank distances!',
    emptyPetBreed: 'Enter the breed of your pet!',
    petBreedSymbol: 'Your pet breed may contain letters and blank distances!',
    emptyPetSex: 'Enter the gender of your pet!',
    petSexSymbol: "Your pet's gender may contain letters and blank distances!",
    emptyPetBirthDay: 'Enter the date of birth of your pet!',
    petBirthDaySymbol: "Your pet's birth date may contain numbers and symbols!",
    emptyPetCoat: "Enter your pet's fur coat!",
    petCoatSymbol: "Your pet's hair cover can contain letters and blanks!",
    regNumberError: 'Registration number is required!',
    clicniError: 'Field clinic is required!',
    notFound: 'The page is not found',
    petIsRegistrated: 'This pet is already registered, if you would like to add a pet, please return to the homepage.',
    notPayed: 'In order to be able to view, rub and add examinations to your pet, you must pay the proper fee for it!',
    notPayedFee: 'The pet is registered in the system, but the annual fee is not paid and the information cannot be displayed!',
    doctorAutorization: 'To be able to view, delete and add examinations, please contact your pet owner to add you to your "Favorite Vets"!'
  },
  payment:{
    paymentTitle: 'Payments',
    paymentText: 'Remaining time to pay for ',
    paymentDays: 'Days',
    markForPay: 'Mark for payment: ',
    paypal: 'Payment via Paypal',
    totalPrice: 'due amount: ',
    totalCurrency: 'USD',
    description: 'Annual fee to the pet system MEPP',
    price: '12,50',
    pay: 'Payment',
    successPayment: 'Your payment was received successfully. You will receive an email with details of the payment made.',
    errorPayment: 'An error occurred with your payment, please try it again!',
    redirectBorika: 'You will be redirected to the virtual payment platform '
  },
  regis: {
    title: 'Registrations in MEPP:'
  },
  flags: {
    flag:[{
      value: 'bg_BG',
      text: 'BG',
      alt: 'България',
      src: '../assets/flags/bulgaria-flag-icon-64.png'
    },
    {
      value: 'en_EN',
      text: 'EN',
      alt: 'English',
      src: '../assets/flags/european-union-flag-icon-64.png'
    },
    {
      value: 'us_US',
      text: 'US',
      alt: 'English',
      src: '../assets/flags/bulgaria-flag-icon-64.png'
    }]
  },
  aboutUs: {
    about: 'About us',
    firstParagraf: 'The pet is our best friend and part of our family!  ',
    firstParagraf1: 'This maxim is known to all owners when they return home and see the adoration in the eyes of their four-legged friends. In order to be together as long as possible, we must take care of them responsibly.',
    firstParagraf2: "That's why we created MEPP - for all of you who share your life with a fluffy friend. MEPP is the application that combines the features that all pet owners want: ",
    firstQuestion: '-       Quick access to the entire health history of the pet;',
    secondQuestion:'-     Quickly and easily filter only the medical examinations that interest you;',
    thirdQuestion: '-       Constant connection between the owner and the veterinarian;',
    fourtQuestion: '-      Regular notifications of upcoming examinations, vaccinations and deworming;',
    fiveQuestion: '-      Keep all examination photos in one place;',
    secondParagraf3: 'In the development of the system, we combined our own experience, as well as the knowledge and expertise of veterinarians, breeders and other specialists and animal lovers.',
    secondParagraf: "The information in MEPP is available with one click - anytime and anywhere in the world, so that the health card of the pet is always in your hand, via mobile phone. You don't have to worry about remembering when the last vaccine or the last internal deworming pill was. You can now fill in this information online after each examination, and with one click give your veterinarian access to add more necessary details. Because trust in such relationships is most important and we, the founders of MEPP, know this.",
    secondParagraf2: 'Through the application you could even find the location of your lost pet, because through its registration and individual code and chipping, each registered clinic will be able to see the real owner.',
    thirtParagraf: "For us, the responsibility for the health, happiness and well-being of animals is paramount. That's why we offer a service, that will facilitate and improve the future care for them.",
    thirtParagraf1: 'Be responsible to those you love.',
    thirtParagraf2: 'MEPP is already working for you!'
  },
  faq:{
  title: 'FAQs',
  pageTitle: 'Frequently Asked Questions',
  faq:
  [
    {
      q:'What should I do if I lose my pet?',
      a: 'Report to the police by providing your pet information from the Municipal Pet Registry.'
    },
    {
      q:'Where to report a stray dog? ',
      a: 'The Institution for the Protection of Animals in Bulgaria is BFSA.'
    },
    {
      q:'Which institution should I refer to as an abusive pet? ',
      a: 'The answer to this question varies depending on the country and city you are in. For Bulgaria, these are the regional directorates of BFSA.'
    },
    {
      q:'After which vaccination can I take my pet out? ',
      a: 'It is advisable to make all the vaccines before you bring your pet out. '
    },
    {
      q:'Do the animals solicit hair for a hairdresser? ',
      a: 'Generally, animals are sedated but conscious. If they are calm, they can be missed.'
    },
    {
      q:'How often is a tartar cleaned?',
      a: 'The answer here is individual, but generally every 6 months.'
    },
    {
      q:'Is It Useful For Cats To Be Castrated? ',
      a: 'Castration is assumed to extend the life of your pet.'
    },
    {
      q:'Castration is assumed to extend the life of your pet.',
      a: 'Usually within the first year of their lives.'
    },
    {
      q:'How often do cats disinfect? ',
      a: 'It depends on whether the pet lives indoors or outdoors. If there is free access to the environment, it is advisable to disinfect every 3-4 weeks. '
    },
    {
      q:'What should I do if I lose my pet passport? ',
      a: "Go to the vet who originally issued your pet's passport. He should keep his information and issue you a duplicate."
    }
  ]},
  footer: {
    allRights: 'All rights reserved'
  },
  menu:{
    followUs: 'Follow Us: '
  },
  dbTransalte: {
    langCode: 'en_EN',
    subject: 'forgotten password',
    hello: 'Hello',
    message: 'if you would like your password to be updated, please click the button:',
    regards: 'Best regards,',
    team : 'MEPP team',
    confirm: 'I approve'
  },
  emailTransalte: {
    langCode: 'en_EN',
    subject: 'Message related to ',
    hello: 'Hello',
    message:'You have a new message related to',
    regards: 'Best regards,',
    team : 'MEPP team',
    noMessage: 'If you no longer wish to receive notifications for your pet, you can exclude email notifications from your profile',
    goToWebsite:'Please visit our website to see the message:'
  },
  emailPaymentTransalte: {
    langCode: 'en_EN',
    subject: 'Payment for ',
    hello: 'Hello',
    message:'You have a new message regarding payment for annual access to our services.',
    regards: 'Best regards,',
    team : 'MEPP team',
    noMessage: 'If you no longer wish to receive notifications for your pet, you can exclude email notifications from your profile',
    goToWebsite:'Please visit our website to pay.'
  },
  gdpr:{
    header: 'PRIVACY POLICY',
    secondHeader: 'OF ‘K AND D SYNERGY’ OOD',
    thirdHeader: '',
    p1: 'K and D Synergy OOD, UIC 206122486, is an Administrator of personal data, with subject of activity: Sales representation and mediation, wholesale and retail trade, software development, development of online applications and platforms, consulting services, management and management services, marketing and advertising services, investments, trade, intermediary services, intermediary services in asset transactions, and all other activities not prohibited by law.',
    p2: 'K and D Synergy OOD owns and operates an online platform My e-passport for pets (MEPP) with the website: ',
    site:'https://my-epet.com/',
    p3: 'My e-passport for pets (MEPP) is an online platform for communication between veterinarians and pet owners. The platform aims to help pet owners have access to the information they need, related to the health of their pets. MEPP provides an active exchange of information between veterinarians and their patients, and through intensive internal communications and website maintenance.',
    dh: 'Contacts:',
    dc: 'Country: Bulgaria',
    dc1: 'Registered address: Sofia 1000, Mladost Region, Mladost 1 neighborhood,bl.40, fl.6, ap.21',
    dp: 'Tel: 0886542129',
    de: 'Е-mail: myepet.passport@gmail.com;',
    p4: 'By carrying out its activity, K and D Synergy OOD performs lawful and regulated personal data collection, processing and storage in accordance with Regulation (EU) No 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of individuals with regard to the processing of personal data and on the free movement of such data (referred to as ‘GDPR’) and the national data protection legislation.',
    h1: 'The personal data we collect from you as a user of the website ',
    h2: ', and process, are:',
    p5: 'Name, surname, mobile phone, e-mail (working place for veterinarians).',
    h3: 'We declare that the personal data we collect will be used solely for the following purposes:',
    t1: '•	For the purposes of using and functioning of the site  ',
    t2: ' and the services offered by it;',
    t3: '•	For the purposes of exercising the legitimate interest of K and D Synergy OOD.',
    h4: 'Legal grounds for processing personal data:',
    d1: '•	Consent of users;',
    d2: '•	Implementations of the Company’s obligations under the national legislation.',
    d3: '•	Legitimate interest;',
    p6: 'The processing is necessary in view of the use of the site and its functionalities, as well as activities of legitimate interest to K and D Synergy OOD.',
    h5: 'Objectives and principles',
    p7: 'K and D Synergy OOD complies with all the principles, incorporated in Chapter two of GDPR when processing your personal data, including:',
    t4: '-	legitimacy, good faith and transparency;',
    t5: '-	limitation of processing objectives;',
    t6: '-	subordination of the purposes of processing on an equal basis with minimization of the collected data;',
    h6: 'K and D Synergy OOD does not collect or process sensitive personal data, including:',
    t7: '- reveal racial or ethnic origin;',
    t8: '- reveal political opinions, religious or philosophical beliefs, or trade-union membership;',
    t9: '- genetic and biometric data, data concerning health or sex life and sexual orientation.',
    p8: 'You must be at least 16 years old to be able to create your registration at   ',
    p9: '. K and D Synergy OOD. does not require or knowingly collect personal data from or for children under the age of 16 without the consent of a parent or guardian. However, if the Company finds out that personal data relating to children under the age of 16 have been provided to it without the consent of a parent or guardian, this information will be deleted as soon as possible or, if deletion is not possible, the personal data will not be used for any purpose and will not be disclosed to third parties.',
    h7: 'K and D Synergy OOD processes data:',
    t10: '- provided by the data subject (user of the website) upon registration (or profile redaction) on the website ',
    t11: '- submitted (entered on the site) by a veterinarian, registered in the website.',
    t12: '- Provided through Declaration.',
    h8: 'Providing your personal data for processing',
    p10: 'In the event of necessity to pass on your personal data to other third parties, this will be done after your explicit consent and subject to the applicable personal data protection legislation.',
    p11: 'In order to fulfil the obligations of the controller in the field of accounting and tax legislation, in compliance with a legal obligation, K and D Synergy OOD may provide your data to the relevant state bodies and third parties –tax authorities and social insurance institutions, courts, bailiffs, public contractors and authorities and others.',
    h9: 'Providing personal data to third countries',
    p12: 'K and D Synergy OOD is committed not to transfer your personal data to third parties outside the EU or to international organizations without expecting to obtain your consent.',
    p13: 'K and D Synergy OOD considers it necessary to notify that for the purposes of processing your personal data, information systems are used to organize the database, and support IT services for applications to these systems, which are used by all (external) persons. ',
    h10: 'Cookies',
    p14: 'K and D Synergy OOD considers it necessary to inform you that for the purposes of using the services through the website (',
    p15: '), K&D Synergy Ltd. uses ‘Cookies’.',
    p16: 'The Cookies help K and D Synergy OOD to understand the preferences and interests of the users of the website, based on their previous and/or current activity on the site. The information obtained as a result of the use of cookies helps K and D Synergy OOD to improve the service and functionalities and services of the site that K and D Synergy OOD provides to users.',
    h11: 'Time limits for storage of personal data',
    p17: 'K and D Synergy OOD has access to or retains your personal data for a period not exceeding the time required for program work on the application or no longer than the term of use of the company’s applications and software systems.K and D Synergy OOD will store your personal data for no longer than the time limits set in the laws and regulations of the current labor, tax and social security legislation and the Company’s internal rules.',
    h12: 'Your rights as a subject of personal data',
    p18: 'As a subject of personal data, you have the following rights:',
    h13: 'Withdrawal of the consent ',
    p19: 'АIf you do not wish all of your personal data or part of it to continue to be processed by K and D Synergy OOD for a specific or all processing purposes, you may, at any time, withdraw your consent to processing by filling in the application form or by free format request. K and D Synergy OOD may ask you to certify your identity with the person subject to this data. By withdrawing the consent to the processing of personal data that is required to create and maintain your registration for the use of applications and software systems, your account will become inactive. All data processed until the withdrawal of the consent has been processed legally.',
    h14: 'Right of access',
    p20: 'You have the right to require and receive a confirmation from K and D Synergy OOD in case any personal data relating to you is being processed. You have the right to access your personal data as well as the information concerning the collection, processing and storage of the above mentioned data. K and D Synergy OOD provides you with a copy of the processed personal data relating to you, upon request, in written or electronic form, if possible. Providing access to the data is free of charge but K and D Synergy OOD reserves the right to impose an administrative fee in the event of excessive claims and misuse of this right.',
    h15: 'Right to rectification or completion',
    p21: 'You may fill in and/or correct your incomplete/incorrect personal data from your account (profile) in the website ',
    p22: ' , or request K and D Synergy OOD to correct your incorrect or incomplete personal data.',
    h16: 'Right to erasure',
    p23: 'You have the right to require K and D Synergy OOD to delete your personal data and K and D Synergy OOD has the obligation to do so without undue delay when any of the following reasons exists: ',
    t13: '-	personal data are no longer needed for the purposes they were collected for or otherwise processed; ',
    t14: '-	you withdraw your consent the processing of the data is based on and there is no other legal basis for the processing; ',
    t15: '-	you object to the processing of your personal data and there are no legitimate grounds, contractual obligations or legitimate interest in the processing that will take precedence; ',
    t16: '-	your personal data has been unlawfully processed. ',
    t17: '-	your personal data must be deleted in order to comply with a legal obligation under EU law or the law of a Member State that applies to K and D Synergy OOD;',
    p24: 'K and D Synergy OOD is not obliged to delete personal data if it stores and processes it:',
    t18: '-	to comply with a legal obligation which requires processing, provided in EU law or the law of the Member State applied to the Administrator, to the performance of a task in the public interest or in the exercise of the official powers conferred on it;',
    t19: '-	for the establishment, exercise or protection of legal claims.',
    t20: '-	for the purposes of archiving in the public interest, for scientific or historical research or for statistical purposes, in so far as the erasure is likely to make it impossible or seriously impede the achievement of the purposes of such processing or to establish, exercise or defend legal claims.',
    h17: 'Right to restriction of processing',
    p25: 'You have the right to contact K and D Synergy OOD to limit the processing of your personal data, in which case you will identify yourself, but not process otherwise. The refusal is not limited and will be explicit only in writing, considering that it must be motivated by lawful cases.',
    h18: 'Right to data portability',
    p26: 'You have the right to request K and D Synergy OOD to directly transmit your personal data to another administrator, specified by you where technically feasible.',
    h19: 'Right to receive information',
    p27: 'You have the right to request K and D Synergy OOD to inform you of all recipients who your personal data have been disclosed to, for which correction, erasure, or limitation of processing was requested. K and D Synergy OOD may refuse to provide this information if this would be impossible or would require disproportionate effort;',
    h20: 'Your rights in case of personal data breach ',
    p28: 'When K and D Synergy OOD detects personal data breach, which is likely to result in a high risk to your rights and freedoms, we communicate the personal data breach to you without undue delay, as well as the measures taken or proposed to be taken.',
    p29: 'K and D Synergy OOD is not obliged to inform you if:',
    t21: '-	the company has implemented appropriate technical and organizational protection measures, and those measures were applied to the personal data affected by the personal data breach;',
    t22: '-	the company has taken subsequent measures which ensure that the high risk to your rights is no longer likely to materialize;',
    t23: '-	the notification would require disproportionate effort.',
    h21: 'Right to object',
    p30: 'You have the right, at any time on, to object to the processing of your personal data by K and D Synergy OOD even if this is done solely for statistical purposes or to assess customer satisfaction.In case of violation of your rights according to the above mentioned principles or the applicable data protection legislation, you could file a complaint before the Bulgarian Personal Data Protection Commission as follows:',
    p31: 'Seat and registered office – 2 Prof. Tsvetan Lazarov Blvd., Sofia 1592, Bulgaria.',
    p36: 'Telephone: 02 915 3 518',
    p32: 'Email: kzld@government.bg , kzld@cpdp.bg',
    p33: 'Website: www.cpdp.bg',
    p34: 'You can also address your complaint to a supervisory authority at your usual living or working place, or the place where the breach took place, in case you assume that there is breach of the Regulation (EU) 2016/679 and / or the national personal data legislation.',
    p35: 'In case you wish to submit a complaint for processing of your personal data through K and D Synergy OOD, you can find the contact details of K and D Synergy OOD appointed herein and on the website.',
    h22: 'Prices and Cancellation Policy',
    p36: 'The Platform has prices in USD. The amount that the User pays for the Service is final and includes VAT. K&D Synergy practices a strict cancellation policy and the Consumer should keep in mind that: ',
    t22: '- K&D Synergy will do everything necessary to preserve the rights and legitimate interests of Users',
    t23: '- K&D Synergy is not liable for non-compliance or incorrect performance of the General Terms and Conditions, if the reasons are due to the User, actions of a third party unrelated to the General Terms and Conditions, unforeseeable events and force majeure by K&D Synergy or its counterparties.',
    t24: '- In case the User has not made a payment or has violated the payment deadlines, but has not notified K&D Synergy that he will not use the Service, K&D Synergy has the right without the consent of the User to cancel the Service, in which case Kay and Di Synergy is not liable to the User and does not owe compensation or penalties. ',
    p37: 'The platform offers the User the following possible types of payments:',
    t25: "-	Payment online with a bank card - Payment is made by reference to an online payment platform, where the user makes the payment by providing K&D Synergy's partner with his bank details. K&D Synergy does not store or administer bank card data, precisely because the payment itself does not take place on its own, but on a partner platform, certified that it has the right to operate with the relevant data. ",
    p38: 'In case the payment is made with a bank card, the refund is made by ordering a reverse operation on the card with which the payment was made within 3 (three) days.',
    p39: 'K&D Synergy confirms the Services requested by the User by email. The user agrees to receive information about promotions or news from the Platform site. ',
    h23: 'Change of conditions',
    p40: 'K&D Synergy reserves the right to unilaterally change the General Terms and Conditions, as well as the structure of its website, which it undertakes to notify Users by publishing a notice on the K&D Synergy homepage within 7 (seven) days, as of the occurrence and / or publication of the change of the General Terms and Conditions.'
  },
  generalTerms: {
    button: 'General terms',
    title: 'GENERAL TERMS AND CONDITIONS FOR USING THE ONLINE PLATFORM ',
    link: 'https://my-epet.com/',
    h1: 'I.	SUBJECT MATTER AND GENERAL PROVISIONS',
    p1: '1.	These General Terms and Conditions (hereinafter referred to as the "General Terms and Conditions") for using the online platform for communication between veterinarians and pet owners ',
    p2: ' (hereinafter referred to as the Platform) and for the use of the services provided through it, regulate the relations between K&D Synergy OOD, with UIC 206122486 (called K&D Synergy for short), in its capacity as a trader and the owner of the Platform, on the one hand, and any person, including a veterinarian, and / or pet owner (hereinafter referred to as "User"), on the other hand, who uses the Platform in any way.',
    p3: '2.	For the purposes of the General Terms and Conditions, the Platform is the following website located at the following internet domain address ',
    p4: ', as well as any other website registered by K&D Synergy.',
    p5: '3.	The platform works to help users, as pet owners, have access to the information they need related to the health of their pets and provides an active exchange of information between veterinarians and their patients, and through intensive internal communications and maintenance of a web page. and other services (hereinafter referred to as Services), which are prepared, offered and provided by K&D Synergy.',
    p6: '4.	By using the Platform, the User agrees with the General Terms.',
    p7: '5.	The User undertakes to use the Platform and the Services in accordance with the requirements of these Terms and Conditions, as well as the Privacy Policy published on the Platform.',
    p8: '6.	In case the User does not agree with any of the General Terms, the User is not able to use the Platform and / or the Services and it is possible to terminate your participation as a party to the General Terms by terminating the use and access of the Platform.',
    p9: '7.	The Platform recommends the use of the Platform and the Services by adults, or by minors, through their legal representatives.',
    h2: 'II. USE OF THE PLATFORM AND SERVICES PROVIDED',
    p10: '8.	All questions of the User or third parties related to the use of the Platform may be asked by the User or by a third party by sending a message in the question form to the e-mail myepet.passport@gmail.com, or of specified in the "Help" section or another section of the Platform created for this purpose.',
    p11: '9.	Each User who uses the Platform has the right to express an opinion regarding the Platform by sending a personal message to K&D Synergy by e-mail myepet.passport@gmail.com .',
    p12: '10.	The User, or any other third party, undertakes to notify of errors, technical problems and other problems related to the use of the Platform by sending a personal message to K&D Synergy by e-mail myepet.passport@gmail.com .',
    p13: '11.	The platform is the subject of creative activity and is under the protection of the Copyright and Related Rights Act, therefore any copying and / or reproduction of any part of the content, mechanical, electrical and logical signals, and / or protocols from the Platform, as well as any other infringement of copyright and related rights, trademark rights or other intellectual property rights, in accordance with the Copyright and Related Rights Act.',
    p14: '12.	Each User who uses the Platform has the right to express an opinion regarding the Platform by sending a personal message to K&D Synergy. ',
    p15: '13.	When using Services in which messages or other types of content are published on the Platform, the infringement of copyright and related rights, trademark rights or other intellectual property rights is prohibited.',
    p16: '14.	All questions of the User or third parties related to the use of the offered Services on the Platform may be asked by the User or by the third party by sending a personal message to K&D Synergy.',
    p17: '15.	The Services are subject to creative activity and are protected by the Copyright and Related Rights Act, therefore any copying and / or reproduction of any part of their content, as well as any other violation of copyright and related rights, trademark rights or other intellectual property rights under the Copyright and Related Rights Act.',
    p18: '16.	The Services may be subject to trade secrets and are protected by Commercial Law, therefore K&D Synergy and the User are obliged to keep the trade secret of K&D Synergy and the persons who have assigned K&D Synergy to perform certain work. as well as their commercial prestige.',
    p19: '17.	The Platform may contain errors, omissions, delays in updating data and information, as well as interrupt access to it, so K&D Synergy reserves the right to edit the Platform and terminate access to it at any time.',
    h3: 'III. USER',
    p20: '18.	Users within the meaning of these General Terms and Conditions may be all able-bodied and adult individuals',
    p21: '19.	Each User, or a third party, before, and / or during, and / or after each use of the Platform and / or the Services, undertakes:',
    p22: '19.1. By any action, or inaction, not to harm, and / or violate, and / or presuppose, and / or threaten to violate the good name of K&D Synergy, and / or the current legislation in the Republic of Bulgaria, international acts, as well as not to jeopardize the operability of the software and technical means through which the Services are provided, including other enterprises providing electronic communications services',
    p23: '19.2.	Not to disseminate obscene, offensive or threatening texts and / or images, including racial, through the Internet, and / or via SMS, and / or through the Platform, and / or through the Services, and / or in any other way. , religious, religious or political grounds, as well as for inciting, preparing or aiding and abetting any of the offenses in the Penal Code, as well as for trampling and / or discriminating against any of the human rights under the Charter of Rights of the European Union, and for the distribution of any personal, public, advertising, or commercial communications.',
    p24: '20.	Each User, or a third party, when using the Platform and / or the Services, in case he participates in forums, blogs, or any other communication in the Platform, undertakes to comply with the following requirements:',
    p25: '20.1.	To post messages written only in Bulgarian, and has the right to use the written characters in Latin only for the purpose of clarifying the expression, as well as in technological terms, trademarks and brands, idioms and jargon. Texts in English or another language will be edited by the respective administrators of the respective website.',
    p26: '20.2.	Not to place / use obscene, offensive or threatening texts and / or images on the Platform, including those on racial, religious, religious or political grounds, as well as for inciting, preparing or aiding and abetting any of the crimes in the Penal Code, as well as for the suppression and / or discrimination of any human rights under the Charter of Rights of the European Union, and for the dissemination of any personal, public, advertising or commercial communications.',
    p27: '20.3.	Do not place on the Platform commercial, advertising texts and / or images, as well as off-topic messages.',
    p28: '20.4.	Do not use a device or software in an attempt to interfere with the proper functioning of the Platform.',
    p29: '21.	Any information, publications, and / or other objectified in any way statements of intent of Users, visitors, customers or other persons outside K&D Synergy belong to its author and K&D Synergy is not responsible for their truthfulness and authenticity.',
    p30: '22.	The User is solely liable for all damages resulting from infringement of property rights and other damages resulting from the use of the Platform.',
    p31: '23.	The User has the right to use the Platform, to save parts of it on a personal computer and to print its contents for personal, non-commercial purposes.',
    p32: `24.	In the event that information published on the Platform infringes someone's intellectual property rights, please contact us at the indicated contacts to take the necessary measures.`,
    h4: 'IV.	RESPONSIBILITY',
    p33: '25.	K&D Synergy is not liable to the User and / or third parties in the following cases:',
    p34: '25.1.	in case of losses, lost profits and other damages caused to the User or third parties as a result of the use of services through the Platform and the page by the User, as well as for the impossibility to use these services;',
    p35: '25.2.	in case of inability of the User to use and / or interpret each individual service;',
    p36: '25.3.	in case of claims by third parties against the User during, and / or in connection with the use of the services;',
    p37: '25.4.	if in case of violations of the operability of the software or technical provision of other providers on the Internet or of the electronic communications in the country and / or abroad, a registered User cannot use partially or completely the possibilities of the services provided on the Platform.',
    h5: 'V.	PRICES AND CANCELLATION POLICY',
    p38: '26.	The Platform has prices in USD.',
    p39: '26.1.	The amount that the User pays for the Service is final and includes VAT.',
    p40: '27.	K&D Synergy practices a strict cancellation policy and the Consumer should keep in mind that: ',
    p41: '27.1.	K&D Synergy will do everything necessary to preserve the rights and legitimate interests of Users',
    p42: '27.2.	K&D Synergy is not responsible for non-fulfillment or incorrect fulfillment of the General Terms and Conditions, if the reasons are due to the User, actions of a third party unrelated to the General Terms and Conditions, unforeseeable events and force majeure by K&D Synergy or its counterparties. ',
    p43: '28.	In the event that the User has not made a payment or has violated the payment deadlines, but has not notified K&D Synergy that he will not use the Service, K&D Synergy has the right without the consent of the User to cancel the Service, in which case Kay and Di Synergy is not liable to the User and does not owe compensation or penalties. ',
    p44: '29.	In case the User wishes to make a change on a request for a Service already made by him, it is necessary, through a written request, to contact K&D Synergy as early as possible before the date of launching the Service to request the necessary changes.',
    p45: '30.	K&D Synergy reserves the right to refuse and / or terminate a request for Service to any pet owner, in its capacity as a User, in the event that any veterinarian registered on the Platform, under any is the reason, suspended your registration in the Platform. If due to impossibility to refuse and / or terminate a request for the Service and unwillingness to use the Service by a pet owner, as a User, K&D Synergy is not obliged to return the amount for the Service, as such claims are submit in writing to K&D Synergy, which is approached individually. ',
    p46: '30.1.	In case of discrepancies and / or disputes, the User should contact directly the veterinarian registered in the Platform, and for such an error K&D Synergy is not responsible and in case of signaling by a User, and / or veterinarian, K&D Synergy is obliges to enter complete and accurate information.',
    p47: '31.	After requesting and paying for the Service, the User has the right to withdraw from the Service within the period established by the Consumer Protection Act, without giving reasons, within 14 (fourteen) days from the payment of the Service by sending in writing application for refusal of the Service to K&D Synergy OOD, UIC 206122486, with registered office in Sofia and address of management in Mladost district, residential complex Mladost 1, block 40, floor 6, apartment 21, or by sending an e-mail to the e-mail myepet.passport@gmail.com and in the latter case, K&D Synergy will send to the e-mail specified by the User for acknowledgment of receipt of the refusal.',
    p48: `32.	When the User has exercised his right to withdraw from the Distance Service or the off-premises contract, K&D Synergy shall refund all amounts received by the User without undue delay and no later than 14 days from the date on which it is was notified of the User's decision to withdraw from the Service, as K&D Synergy refunds the amounts received using the same means of payment used by the User in the initial transaction, unless the User has expressly agreed to use another means of payment and provided that this does not involve costs for the User.`,
    p49: '32.1.	In case the payment is made with a bank card, the refund is made by ordering a reverse operation on the card with which the payment was made within 7 (seven) days.',
    p50: '33.	In any case of refusal of the User from the Service, K&D Synergy refunds the amount for the period from the receipt of the refusal by the User until the expiration of the Service.',
    p51: '34.	The platform offers the User the following possible types of payments:',
    p52: `34.1.	Payment online with a bank card - Payment is made by reference to an online payment platform, where the user makes the payment by providing K&D Synergy's partner with his bank details. K&D Synergy does not store or administer the bank card data, precisely because the payment itself does not take place on its own, but on a partner platform, certified that it has the right to operate with the relevant data. `,
    p53: '35. In case the payment is made with a bank card, the refund is made by ordering a reverse operation on the card with which the payment was made within 3 (three) days.',
    p54: '36.	K&D Synergy confirms the Services requested by the User by email. The user agrees to receive information about promotions or news from the Platform site. ',
    p56: '37.	The user has the right to unsubscribe from receiving news, through a link in the newsletter received by him, from his profile on the Platform or by sending a personal message to K&D Synergy. ',
    p57: '38.	In case the claims of the User related to the quality of the provided Service are not presented on the spot during the provision of the Service, the User has the right to file a duly filed complaint to K&D Synergy in writing within 14 days of requesting the Service. , at a K&D Synergy office or by sending an email to K&D Synergy.',
    p58: '38.1.	The user is obliged to provide a protocol (complaint), signed by a representative of the veterinarian and by himself, indicating the details of his complaint and describing the situation in detail.',
    p59: '38.2.	In the absence of a bilaterally signed protocol or complaint, the User may not make any claims to K&D Synergy.',
    p60: '38.3.	K&D Synergy undertakes to submit the claims to the veterinarian within one month from the date of request of the Service, after which to continue the correspondence with the User until the dispute is resolved. ',
    p61: '39.	The original version of the Platform (in Bulgarian) can be translated into other languages. In case of a dispute regarding the content or interpretation of a translated version, it should be borne in mind that the original (Bulgarian) version prevails and prevails over the rights and obligations of the user and the company. Any User can access the Bulgarian version by selecting it from the upper right corner of the home page of the Platform. ',
    h7: 'VI.	CHANGE OF CONDITIONS',
    p69: '41.	K&D Synergy reserves the right to unilaterally change the General Terms and Conditions, as well as the structure of its website, which it undertakes to notify Users by posting a notice on the K&D Synergy homepage, within 7 (seven) days, as of the occurrence and / or publication of the change of the General Terms and Conditions.',
    h8: 'VII.	OTHERS',
    p70: '42.	Campaigns, games and promotions in the Platform:',
    p71: '42.1.	The Platform may contain messages about competitions, games and / or promotions in which the User may participate, as well as links to such initiatives (for example on Facebook).',
    p72: '42.2.	K&D Synergy uses the information provided by the User only in the event that the User has agreed to participate in these initiatives in order for K&D Synergy to contact the User.',
    h9: 'VIII. FINAL PROVISIONS',
    p73: '43.	The legislation in force in the Republic of Bulgaria shall apply to all issues not settled in these Terms.',
    p74: '44.	In the event of disputes, the parties shall make efforts for their voluntary settlement by mutual agreement. In case of disagreement, either party may refer the dispute to a competent court.',
    p75: '45.	General Terms and Conditions enter into force on the day of their publication on the Platform.',
    p76: 'For additional questions you can contact us at the contacts listed on the page:',
    p77: 'K&D Synergy OOD, UIC 206122486, with headquarters in Sofia and address of management in Mladost district, residential complex Mladost 1, bl.40, fl.6, ap.21, e-mail myepet.passport@gmail.com'

  }
}
export default us;
